import styled from '@emotion/styled';
import React from 'react';

import {mixinCenterWrapper} from '@ELib/styles/mixins';

export const AuthWorkflow = ({
  Header,
  OuterFooter,
  OuterHeader,
  MainComponent,
}: {
  Header: React.ReactElement | string;
  OuterFooter?: React.ReactElement;
  OuterHeader?: React.ReactElement;
  MainComponent: React.ReactElement;
}): React.ReactElement => (
  <AuthWorkflowBackground>
    <AuthWorkflowWrapper>
      <AuthWorkflowOuterTop>{OuterHeader}</AuthWorkflowOuterTop>
      <LoginBox>
        <AuthWorkflowBoxHeader>{Header}</AuthWorkflowBoxHeader>
        <AuthWorkflowContent>{MainComponent}</AuthWorkflowContent>
      </LoginBox>
      {OuterFooter ? (
        <AuthWorkflowOuterBottom>{OuterFooter}</AuthWorkflowOuterBottom>
      ) : null}
    </AuthWorkflowWrapper>
  </AuthWorkflowBackground>
);

const AuthWorkflowBackground = styled.div`
  ${mixinCenterWrapper};
  height: 100%;
  min-height: min-content;
  background-color: var(--color-core-cockpit-boxes);
`;

const AuthWorkflowWrapper = styled.div`
  width: 500px;
  margin: var(--gutter);
`;

const AuthWorkflowOuterTop = styled.div`
  display: flex;
  justify-content: end;
  align-items: flex-end;
`;

const AuthWorkflowOuterBottom = styled.div`
  ${mixinCenterWrapper}
`;

const LoginBox = styled.div`
  background-color: var(--color-core-white);
  border-radius: var(--card-border-radius);
  margin: auto;
`;

const AuthWorkflowBoxHeader = styled.div`
  padding: var(--gutter);
  background-color: var(--color-core-primary);
  color: var(--color-core-white);
  font-weight: var(--font-weight-title);
  font-size: var(--font-size-title);
  border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
`;

const AuthWorkflowContent = styled.div`
  flex-grow: 1;
  ${mixinCenterWrapper}
`;
